import axios from 'axios';
import { Paginated } from '../../common/types';
import { HormonePatternContent } from '../../common/model/dto/hormone-pattern-content';
import { ADMIN_HORMONE_PATTERN_CONTENTS_ROUTE } from '../../api/backend';

export const loadHormonePatternContents = async (query: string) => {
  const { data } = await axios.get<Paginated<HormonePatternContent>>(
    `${ADMIN_HORMONE_PATTERN_CONTENTS_ROUTE}?${query}`
  );

  return data;
};

export const getHormonePatternContentById = async (id: string) => {
  const { data } = await axios.get<HormonePatternContent>(
    `${ADMIN_HORMONE_PATTERN_CONTENTS_ROUTE}/${id}`
  );

  return data;
};

export const updateHormonePatternContentById = async (
  hormonePatternContentId: string,
  updateObj: Partial<HormonePatternContent>
): Promise<void> => {
  await axios.patch<HormonePatternContent>(
    `${ADMIN_HORMONE_PATTERN_CONTENTS_ROUTE}/${hormonePatternContentId}`,
    updateObj
  );
};
